import { useTranslator } from '@eo-locale/preact';
import { ReviewSorting } from 'types/review';
import { FilterStatuses } from 'types/settings';

export const SortingKeyToLabel = {
  [ReviewSorting.DATE_DESC]: 'reviews_list_most_recent_sort',
  [ReviewSorting.RATING_DESC]: 'reviews_list_highest_rating_sort',
  [ReviewSorting.RATING_ASC]: 'reviews_list_lowest_rating_sort',
  [ReviewSorting.HELPFUL_DESC]: 'reviews_list_most_helpful_sort',
} as const;

type SortingKeyToLabel = keyof typeof SortingKeyToLabel;

export interface SortingOption {
  label: string;
  value: SortingKeyToLabel;
}

export function useGetSortingOptions({
  enable_helpful_filter,
  enable_rating_asc_filter,
  enable_rating_desc_filter,
  enable_recent_filter,
}: FilterStatuses) {
  const { translate } = useTranslator();
  const options: SortingOption[] = [];

  if (enable_helpful_filter) {
    options.push({
      label: translate(SortingKeyToLabel[ReviewSorting.HELPFUL_DESC], {
        defaultMessage: 'Most helpful',
      }),
      value: ReviewSorting.HELPFUL_DESC,
    });
  }

  if (enable_rating_asc_filter) {
    options.push({
      label: translate(SortingKeyToLabel[ReviewSorting.RATING_ASC], {
        defaultMessage: 'Lowest rating',
      }),
      value: ReviewSorting.RATING_ASC,
    });
  }

  if (enable_rating_desc_filter) {
    options.push({
      label: translate(SortingKeyToLabel[ReviewSorting.RATING_DESC], {
        defaultMessage: 'Highest rating',
      }),
      value: ReviewSorting.RATING_DESC,
    });
  }

  if (enable_recent_filter) {
    options.push({
      label: translate(SortingKeyToLabel[ReviewSorting.DATE_DESC], {
        defaultMessage: 'Most recent',
      }),
      value: ReviewSorting.DATE_DESC,
    });
  }

  return options;
}
